<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { SecondaryButton } from '@es-bill/es-bill-common-components';

const { t } = useI18n();

</script>

<template>
  <v-container class="containerStandard mainContainer">
    <v-container class="containerText">
      <p class="textHeadline">
        {{ t('finishedApplication.contractAccepted') }}
      </p>

      <p class="textContainer">
        {{ t('finishedApplication.contractAcceptedDescription') }}
      </p>

      <p class="textDescriptor textContainer">
        {{ t('finishedApplication.closeTab') }}
      </p>
    </v-container>

<!--    <div class="buttons">-->
<!--      <SecondaryButton-->
<!--        href="https://www.so-strom.at/"-->
<!--        target="_blank"-->
<!--        :text="t('soStromWebsite')"-->
<!--      />-->
<!--    </div>-->
  </v-container>
</template>

<style scoped lang="scss">
.mainContainer {
  display: flex;
  padding: 5px 0px 60px 0px;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  max-width: 100%;
}

.containerText {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding: 0 16px;
}

.buttons {
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 0 16px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
}

.textContainer {
  max-width: 467px;
  text-align: center;

  @media (max-width: 600px) {
    max-width: 100%;
    padding: 0 8px;
  }
}

// Additional responsive adjustments
@media (max-width: 768px) {
  .mainContainer {
    gap: 32px;
    padding: 12px;
  }

  .containerText {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .mainContainer {
    gap: 24px;
    padding: 8px;
  }

  .buttons {
    gap: 12px;
  }
}

</style>

